const styles = () => ({
  editFormWrapper: {
    marginLeft: '24px',
    width: 'calc(100% - 24px - 21px)',
  },
});

export default styles;
